import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API, PREFIX_BIGYUER_API } from '@/service'

const api = {
  workerByCondition: PREFIX_SCC_API + 'fchild/worker/queryServiceWorker.do',
  enumData: `${utils.hostname(
    'subscriber'
  )}/subscriber-web/schedual/qryScheduLTermMould.do`,
  workerStars: `${utils.hostname(
    'subscriber'
  )}/subscriber-web/serveStar/getStarInfos.do`,
  activeWorkerStar: `${utils.hostname(
    'subscriber'
  )}/subscriber-web/serveStar/getCurrentStarInfo.do`,
  allWorkers: PREFIX_SCC_API + 'fchild/worker/queryStoreWorker.do',
  cms4StoreWorkers: `${utils.hostname('cms')}/publish/999/promotions.json`,
  serviceCateList: PREFIX_BIGYUER_API + 'serviceCateList'
}

export default {
  // 不分页获取服务人员
  async getWorkerEnumData({ commit, state }) {
    try {
      const data_res = await fetch(`${api.enumData}`)
      const dataJson = await data_res.json()
      if (dataJson.code === '0') {
        const data = dataJson.content.result || {}
        commit('setStarLevelsList', data.starLevels.reverse())
        commit('setServiceTypeList', data.serviceTypes)
      } else {
        throw new Error(dataJson.code)
      }
    } catch (e) {
      throw new Error(e)
    }
  },
  // 根据国标、服务类型获取服务人员
  async getWorkersByCondition(
    { commit, state },
    { pageIndex, pageSize, cityId, districtIds, categoryIds }
  ) {
    try {
      const query_param = {
        pageIndex,
        pageSize,
        cityId,
        districtIds,
        categoryIds
      }
      const query = JSON.stringify(query_param)
      const work_res = await fetch(`${api.workerByCondition}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `param=${encodeURIComponent(query)}`,
        credentials: 'include'
      })
      const workJson = await work_res.json()
      // const workJson = require('./qryScheduListByCityAndService.json')
      let workers = []
      if (workJson.code * 1 === 1) {
        workers = workJson.data || []
        commit('setWorkerList', workers)
      } else {
        throw new Error(workJson.code)
      }
      return workers
    } catch (e) {
      throw new Error(e)
    }
  },
  // 城市／门店服务人员列表
  async getAllWorkers(
    { commit, state },
    { cityId, storeCode, pageSize, pageIndex, userTypes }
  ) {
    try {
      const query_param = {
        cityId,
        storeCode,
        pageSize,
        pageIndex,
        userTypes
      }
      const query = JSON.stringify(query_param)
      const work_res = await fetch(`${api.allWorkers}?`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `param=${encodeURIComponent(query)}`,
        credentials: 'include'
      })
      const workJson = await work_res.json()
      let workers = []
      if (workJson.code * 1 === 1) {
        workers = workJson.data || []
        commit('setAllWorkers', workers)
      } else {
        throw new Error(workJson.code)
      }
      return workers
    } catch (e) {
      throw new Error(e)
    }
  },
  // 获取城市／门店服务人员列表头部的banner
  async getCmsConfig4StoreWorkers({ commit, state }) {
    try {
      const data_res = await fetch(`${api.cms4StoreWorkers}`)
      const dataJson = await data_res.json()
      return dataJson
    } catch (e) {
      throw new Error(e)
    }
  },
  async getWorerStars({ commit, states }, { pageNo, pageSize, type }) {
    try {
      const query_param = {
        type,
        pageNo,
        pageSize
      }
      const query = queryString.stringify(query_param)
      const work_res = await fetch(`${api.workerStars}?${query}`)
      const workJson = await work_res.json()
      let stars = []
      if (workJson.code === '0') {
        if (pageNo === 1) {
          commit('resetWorkerStars')
        }
        stars = workJson.content.result.currentTypeStars || []
        commit('setWorkerStars', stars)
      }
      return workJson
    } catch (e) {
      console.log(e)
    }
  },
  async getActiveWorerStars(store, { pageNo, pageSize }) {
    try {
      const query_param = {
        pageNo,
        pageSize
      }
      const query = queryString.stringify(query_param)
      const work_res = await fetch(`${api.activeWorkerStar}?${query}`)
      const workJson = await work_res.json()
      return workJson
    } catch (e) {
      console.log(e)
    }
  },
  async getServiceCateList({ commit, state }) {
    try {
      const data_res = await fetch(`${api.serviceCateList}`)
      const dataJson = await data_res.json()
      if (dataJson.errno * 1 === 0) {
        const data = dataJson.data || []
        commit('setServiceTypeList', data)
      } else {
        throw new Error(dataJson.errno)
      }
    } catch (e) {
      throw new Error(e)
    }
  }
}
